import { css } from "@emotion/css";
import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import BillingDetailsPopup from "../../components/subscription-component/BillingDetailsPopup";
import CancellationPopup from "../../components/subscription-component/CancellationPopup";
import CancelPlanCard from "../../components/subscription-component/CancelPlanCard";
import CancelPopup from "../../components/subscription-component/CancelPopup";
import CustomPlanCancelPopup from "../../components/subscription-component/CustomPlanCancelPopup";
import CustomPlanCard from "../../components/subscription-component/CustomPlanCard";
import CustomPlanSmallCard from "../../components/subscription-component/CustomPlanSmallCard";
import FeatureCardList from "../../components/subscription-component/FeatureCardList";
import FeedbackPopup from "../../components/subscription-component/FeedbackPopup";
import PlansFeatures from "../../components/subscription-component/PlansFeatures";
import PricePlanCard from "../../components/subscription-component/PricePlanCard";
import SelectPlanCard from "../../components/subscription-component/SelectPlanCard";
import "../../components/subscription-component/style/ComparePlans.scss";
import SuccessfullPopup from "../../components/subscription-component/SuccessfullPopup";
import AppContext from "../../config/AppContext";
import CommonUtil from "../../util/CommonUtils";
import { sidebarContext } from "../../util/context";
import {
  createSubscription,
  upgradeSubscription,
} from "../../services/Subscription";
import RedirectPage from "../../components/subscription-component/RedirectPage";
import { toast } from "sonner";
import { Box } from "@mui/material";
import BillingAddressForm from "../../components/subscription-component/BillingAddressForm";

const ComparePlans = ({
  isActivePlan,
  monthlyPlanAndFeature,
  yearlyPlanAndFeature,
  isLoading,
  navigation,
  subscriptionDetails,
  ...props
}) => {
  const { t } = useTranslation();
  const { mode } = useContext(AppContext);
  // const { subscriptionDetails } = useContext(sidebarContext);
  const [planType, setPlanType] = useState("months");
  const [openCustomPlan, setOpenCustomPlan] = useState(false);
  const [openCancelPlan, setOpenCancelPlan] = useState(false);
  const [openFeedbackPopup, setOpenFeedbackPopup] = useState(false);
  const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
  const [isFailurePopupOpen, setIsFailurePopupOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState([]);
  const [otherReason, setOtherReason] = useState("");
  const [openBillingSetup, setOpenBillingSetup] = useState(false);
  const [billingData, setBillingData] = useState({});
  const [openRedirectPage, setOpenRedirectPage] = useState(false);
  const [planList, setPlanList] = useState([]);
  const [totalPlan, setTotalPlan] = useState(-1);

  const [showBillingDetails, setShowBillingDetails] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleFeedbackFailure = () => {
    setOpenFeedbackPopup(false);
    setSelectedReason(selectedReason);
    setOtherReason(otherReason);
    setTimeout(() => {
      setIsFailurePopupOpen(true);
    }, 150);
  };

  const handleFeedbackSubmit = () => {
    setOpenFeedbackPopup(false);
    setIsFailurePopupOpen(false);
    setTimeout(() => {
      setIsSuccessPopupOpen(true);
    }, 150);
  };

  const handleRetry = () => {
    setIsFailurePopupOpen(false);
    setOpenFeedbackPopup(true);
  };

  const handleFeedbackClose = () => {
    setSelectedReason(null);
    setOtherReason("");
    setOpenFeedbackPopup(false);
  };
  useLayoutEffect(() => {
    setPlanType(subscriptionDetails?.plan?.intervalUnit);
  }, [navigation, monthlyPlanAndFeature, yearlyPlanAndFeature]);

  const cancelStatus = ["cancelled", "non_renewing"];

  useLayoutEffect(() => {
    if (planType === "years") {
      const updatedYearlyPlans = yearlyPlanAndFeature.map((yp) => {
        const mp = monthlyPlanAndFeature.find(
          (mp) => mp.plan.plan_name === yp.plan.plan_name
        );

        // Skip if no matching monthly plan is found
        if (!mp) return yp;

        let discountAmt = 0;
        let ypPrice = yp?.plan?.price_per_user / 12;
        let mpPrice = mp?.plan?.price_per_user; // Monthly price converted to yearly price

        // calculating percents
        if (
          typeof ypPrice === "number" &&
          !isNaN(ypPrice) &&
          typeof mpPrice === "number" &&
          !isNaN(mpPrice)
        ) {
          discountAmt = ((mpPrice - ypPrice) / mpPrice) * 100;
          discountAmt = Math.abs(Math.round(discountAmt));
        }

        // Return a new object with the discountAmt added to the existing yp object
        return {
          ...yp,
          discountAmt,
        };
      });

      if (
        subscriptionDetails?.plan?.intervalUnit !== "years" &&
        !cancelStatus.includes(subscriptionDetails?.status)
      ) {
        setPlanList(
          updatedYearlyPlans.filter(
            (mpf) => mpf.plan.sequence_id > subscriptionDetails?.plan?.planOrder
          )
        );
      } else {
        setPlanList(updatedYearlyPlans);
      }
    }
    if (planType === "months") {
      if (
        subscriptionDetails?.plan?.intervalUnit !== "months" &&
        !cancelStatus.includes(subscriptionDetails?.status)
      ) {
        setPlanList(
          monthlyPlanAndFeature.filter(
            (mpf) => mpf.plan.sequence_id > subscriptionDetails?.plan?.planOrder
          )
        );
      } else {
        setPlanList(monthlyPlanAndFeature);
      }
    }
  }, [planType, navigation, monthlyPlanAndFeature, yearlyPlanAndFeature]);

  useLayoutEffect(() => {
    if (planList.length > 0) {
      let totalCount = 0;
      planList.map((plan, index) => {
        if (navigation === "compare-plan") {
          if (
            plan?.plan.sequence_id > subscriptionDetails?.plan?.planOrder ||
            subscriptionDetails?.status !== "live"
          ) {
            totalCount = totalCount + 1;
          }
        } else if (
          navigation === "back" ||
          subscriptionDetails?.plan?.planCode === "0000"
        ) {
          totalCount = totalCount + 1;
        }
      });
      setTotalPlan(totalCount);
    }
  }, [planList, navigation, monthlyPlanAndFeature, yearlyPlanAndFeature]);
 
  const featureListfromPlan = () => {
    let featureList = [];
    planList.map((pfs) => {
      featureList.push({ feature: pfs.features, planCode: pfs.plan.plan_code });
    });
    return featureList;
  };

  const submitPaymentDetails = (planCode) => {
    setOpenRedirectPage(true);
    let payload = {
      customerId: subscriptionDetails.user.customerId,
      planCode: planCode,
    };
    if (
      !subscriptionDetails?.plan?.trialPlan &&
      subscriptionDetails?.status === "live" &&
      subscriptionDetails.autoCollect
    ) {
      payload = {
        ...payload,
        subscriptionId: subscriptionDetails.user.subscriptionId,
      };
      upgradeSubscription(payload)
        .then((res) => {
          if (res.data.code === "RCI0000") {
            CommonUtil.setCookie(
              "page_id",
              res.data.data.hostedpage_id,
              0.00694
            );
            window.location.href = res.data.data.url;
          } else {
            setOpenRedirectPage(false);
            setOpenBillingSetup(false);
            setTimeout(() => {
              toast.error(res.data.message);
            }, 200);
          }
        })
        .catch((error) => {
          console.log(
            "Error occurs while processing payment: " + error.message
          );
        });
    } else {
      createSubscription(payload)
        .then((res) => {
          if (res.data.code === "RCI0000") {
            CommonUtil.setCookie(
              "page_id",
              res.data.data.hostedpage_id,
              0.00694
            );
            window.location.href = res.data.data.url;
          } else {
            setOpenRedirectPage(false);
            setOpenBillingSetup(false);
            setTimeout(() => {
              toast.error(res.data.message);
            }, 200);
          }
        })
        .catch((error) => {
          console.log(
            "Error occurs while processing payment: " + error.message
          );
        });
    }
  };
  const featureCardListRef = useRef(null);
  const plansFeaturesRef = useRef(null);

  const syncScroll = (sourceRef, targetRef) => {
    if (sourceRef.current && targetRef.current) {
      const source = sourceRef.current;
      const target = targetRef.current;

      const sourceScrollHeight = source.scrollHeight - source.clientHeight;
      const targetScrollHeight = target.scrollHeight - target.clientHeight;
      const scrollRatio = targetScrollHeight / sourceScrollHeight;
      target.scrollTop = source.scrollTop * scrollRatio;
    }
  };

  useEffect(() => {
    const plansFeaturesElement = plansFeaturesRef.current;

    const handlePlansFeaturesScroll = () => {
      syncScroll(plansFeaturesRef, featureCardListRef);
    };

    if (plansFeaturesElement) {
      plansFeaturesElement.addEventListener(
        "scroll",
        handlePlansFeaturesScroll
      );
    }

    return () => {
      if (plansFeaturesElement) {
        plansFeaturesElement.removeEventListener(
          "scroll",
          handlePlansFeaturesScroll
        );
      }
    };
  });

   const handleAddressFormSubmit = () => {
    setShowAddressForm(false);
    setShowBillingDetails(true);
  };

  const handleBillingConfirm = (planCode) => {
    setShowBillingDetails(false);
    submitPaymentDetails(planCode);
  };

  return (
    <>
      {isLoading && (
        <div
          className="compare-plan-main"
          style={{
            gap: totalPlan <= 2 && navigation == "compare-plan" ? "0" : "24px",
          }}
        >
          <div className="compare-plan-container">
            <div
              style={{
                display: "flex",
                gap:
                  totalPlan == 0 && navigation == "compare-plan" ? "0" : "24px",
              }}
            >
              <Box
                sx={{
                  position: "sticky !important",
                  left: "0",
                  zIndex: 99,
                  // boxShadow: scrollActive ? "12px 0px 30px 0px rgba(0, 0, 0, 0.3)" : "none"
                }}
              >
                {totalPlan > 0 && (
                  <SelectPlanCard
                    maxWidth={
                      subscriptionDetails?.plan?.planCode !== "0000" &&
                      navigation === "compare-plan"
                        ? "100%"
                        : "0"
                    }
                    toggle={planType}
                    setToggle={setPlanType}
                  />
                )}
              </Box>
              {planList.map((plan, index) => {
                const price_per_user = plan?.plan?.price_per_user;
                const [price, decimalValue] = price_per_user
                  .toFixed(2)
                  .split(".");
                if (
                  navigation === "compare-plan" &&
                  (subscriptionDetails?.status?.toLowerCase() === "live" ||
                  subscriptionDetails?.status?.toLowerCase() === "expired")
                ) {
                  // Only show plans with sequence_id greater than the current planOrder
                  if (
                    plan?.plan.sequence_id >
                    subscriptionDetails?.plan?.planOrder
                  ) {
                    return (
                      <div className="compare-plan-price-card" key={index}>
                        <PricePlanCard
                          price={price}
                          decimalValue={decimalValue}
                          // openBillingDetails={() => {
                          //   setBillingData({ billingType: planType, ...plan });
                          //   setOpenBillingSetup(true);
                          // }}
                          openAddressForm={() => {
                            setSelectedPlan({ billingType: planType, ...plan });
                            setShowAddressForm(true);
                          }}
                          isFreeTrail={plan?.plan?.plan_code === "0000"}
                          planName={plan.plan.plan_name}
                          discountAmt={
                            planType === "years" ? plan.discountAmt : ""
                          }
                          isActivePlan={
                            subscriptionDetails?.status == "live" &&
                            plan.plan.plan_code ===
                              subscriptionDetails?.plan?.planCode
                          }
                        />
                      </div>
                    );
                  }
                } else if (
                  navigation === "back" ||
                  subscriptionDetails?.plan?.planCode === "0000" ||
                  (navigation === "compare-plan" &&
                    cancelStatus.includes(subscriptionDetails?.status))
                ) {
                  // When navigation is "back", show all plans equal or greater than current order
                  return (
                    <div className="compare-plan-price-card" key={index}>
                      <PricePlanCard
                        price={price}
                        decimalValue={decimalValue}
                        isFreeTrail={plan?.plan?.plan_code === "0000"}
                        // openBillingDetails={() => {
                        //   setBillingData({ billingType: planType, ...plan });
                        //   setOpenBillingSetup(true);
                        // }}
                         openAddressForm={() => {
                            setSelectedPlan({ billingType: planType, ...plan });
                            setShowAddressForm(true);
                          }}
                        planName={plan.plan.plan_name}
                        discountAmt={
                          planType === "years" ? plan.discountAmt : ""
                        }
                        isActivePlan={
                          subscriptionDetails?.status == "live" &&
                          plan.plan.plan_code ===
                            subscriptionDetails?.plan?.planCode
                        }
                      />
                    </div>
                  );
                }

                return null; // Return null if no conditions match
              })}

              {totalPlan <= 2 &&
                totalPlan !== 0 &&
                navigation == "compare-plan" && (
                  <>
                    {totalPlan === -1 ? (
                      <></>
                    ) : (
                      <CustomPlanSmallCard
                        maxWidth={"100%"}
                        openCustomPlan={setOpenCustomPlan}
                      />
                    )}
                  </>
                )}
              {totalPlan == 0 && navigation == "compare-plan" && (
                <>
                  <CustomPlanSmallCard
                    maxWidth={"50%"}
                    openCustomPlan={setOpenCustomPlan}
                    marginRight={"12px"}
                  />
                  {subscriptionDetails?.status == "live" ||
                  subscriptionDetails?.status == "card_expired" ? (
                    <CancelPlanCard
                      maxWidth={"50%"}
                      marginLeft={"12px"}
                      remainingDays={CommonUtil.calculateRemainingDays(
                        subscriptionDetails?.nextBillingAt
                      )}
                      onClick={() => setOpenCancelPlan(true)}
                    />
                  ) : (
                    <></>
                  )}
                </>
              )}
            </div>

            {totalPlan > 0 && navigation !== "compare-plan" && (
              <Box
                className={css`
                  // height: calc(100vh - 537px) !important;
                  height: calc(
                    100vh -
                      ${subscriptionDetails?.plan?.planCode === "0000"
                        ? 538
                        : 567}px
                  ) !important;
                  display: flex;
                  gap: 24px;
                  @media (max-width: 1600px) {
                    height: calc(
                      100vh -
                        ${subscriptionDetails?.plan?.planCode === "0000"
                          ? 416
                          : 450}px
                    ) !important;
                  }
                  @media (max-width: 1440px) {
                    height: calc(
                      100vh -
                        ${subscriptionDetails?.plan?.planCode === "0000"
                          ? 420
                          : 454}px
                    ) !important;
                  }
                  @media (max-width: 1280px) {
                    height: calc(
                      100vh -
                        ${subscriptionDetails?.plan?.planCode === "0000"
                          ? 420
                          : 457}px
                    ) !important;
                  }
                `}
              >
                <Box
                  ref={featureCardListRef}
                  sx={{
                    position: "sticky",
                    left: "0",
                    zIndex: 99,
                    overflowY: "auto",
                  }}
                >
                  <FeatureCardList />
                </Box>
                <Box
                  ref={plansFeaturesRef}
                  sx={{
                    overflowY: "auto",
                    display: "flex",
                    gap: "24px",
                  }}
                >
                  {featureListfromPlan().map((features, index) => {
                    return (
                      <span
                        className="compare-plan-feature-list-content"
                        key={index}
                      >
                        <PlansFeatures
                          index={index}
                          planFeature={features.feature}
                          isActivePlan={
                            subscriptionDetails?.status == "live" &&
                            features.planCode ===
                              subscriptionDetails?.plan?.planCode
                          }
                        />
                      </span>
                    );
                  })}
                </Box>
              </Box>
            )}
          </div>
          <div className="compare-plan-custom" style={{ paddingRight: "2px" }}>
            {navigation && navigation !== "compare-plan" ? (
              <CustomPlanCard
                openCustomPlan={setOpenCustomPlan}
                subscriptionDetails={subscriptionDetails}
              />
            ) : totalPlan === -1 ? (
              <></>
            ) : totalPlan <= 2 ? (
              <></>
            ) : (
             subscriptionDetails?.plan?.planCode === "0000"?<CustomPlanCard
              openCustomPlan={setOpenCustomPlan}
              subscriptionDetails={subscriptionDetails}
            />: <CustomPlanSmallCard openCustomPlan={setOpenCustomPlan} />
            )}
          </div>
        </div>
      )}
      {totalPlan === -1 ? (
        <></>
      ) : navigation == "compare-plan" &&
        (subscriptionDetails?.status == "live" ||
          subscriptionDetails?.status == "card_expired") &&
        totalPlan !== 0 ? (
        <Box
          sx={{
            position: "absolute !important",
            top: "376px",
            "@media (max-width: 1600px)": {
              top: "278px",
            },
          }}
        >
          <CancelPlanCard
            maxWidth={"100%"}
            remainingDays={CommonUtil.calculateRemainingDays(
              subscriptionDetails?.nextBillingAt
            )}
            onClick={() => setOpenCancelPlan(true)}
          />
        </Box>
      ) : (
        <></>
      )}

      {showAddressForm && (
        <BillingAddressForm
          open={showAddressForm}
          onClose={() => setShowAddressForm(false)}
          onSubmit={handleAddressFormSubmit}
        />
      )}

      {showBillingDetails && selectedPlan && (
        <BillingDetailsPopup
          isOpen={showBillingDetails}
          onClose={() => setShowBillingDetails(false)}
          billingDetails={selectedPlan}
          onConfirm={handleBillingConfirm}
        />
      )}

      {/* {openBillingSetup && (
        <BillingDetailsPopup
          isOpen={openBillingSetup}
          billingDetails={billingData}
          onClose={() => setOpenBillingSetup(false)}
          onConfirm={(planCode) => submitPaymentDetails(planCode)}
        />
      )} */}
      {openRedirectPage && <RedirectPage />}

      {openCustomPlan && (
        <CustomPlanCancelPopup
          open={openCustomPlan}
          onClose={() => setOpenCustomPlan(false)}
          onConfirm={() => setOpenCustomPlan(false)}
          title={t("RAL0864")}
          content={t("RAL0865")}
          email={" sales@ralvie.ai"}
          confirmText={t("RAL1013")}
          cancelText={t("RAL0177")}
        />
      )}
      {openCancelPlan && (
        <CancelPopup
          open={openCancelPlan}
          onClose={() => setOpenCancelPlan(false)}
          onConfirm={() => {
            setOpenCancelPlan(false);
            setOpenFeedbackPopup(true);
          }}
          title={t("RAL0876")}
          content={t("RAL0877")}
          confirmText={t("RAL0879")}
          cancelText={t("RAL0878")}
        />
      )}

      {openFeedbackPopup && (
        <FeedbackPopup
          open={openFeedbackPopup}
          onClose={handleFeedbackClose}
          onConfirm={handleFeedbackSubmit}
          onFailure={handleFeedbackFailure}
          title={t("RAL0881")}
          content={t("RAL0882")}
          confirmText={t("RAL0200")}
          cancelText={t("RAL0177")}
          selectedReason={selectedReason}
          setSelectedReason={setSelectedReason}
          otherReason={otherReason}
          setOtherReason={setOtherReason}
        />
      )}

      {isSuccessPopupOpen && (
        <SuccessfullPopup
          open={isSuccessPopupOpen}
          onClose={() => setIsSuccessPopupOpen(false)}
        />
      )}

      {isFailurePopupOpen && (
        <CancellationPopup
          open={isFailurePopupOpen}
          onClose={() => setIsFailurePopupOpen(false)}
          onConfirm={handleRetry}
          selectedReason={selectedReason}
          setSelectedReason={setSelectedReason}
          otherReason={otherReason}
          setOtherReason={setOtherReason}
        />
      )}
    </>
  );
};

export default ComparePlans;
